import styled from 'styled-components';
import { useFilterContext } from '../../contexts/FilterContext';
import { ANNUAL_MULTI_YEAR, MULTI_YEAR } from '../../constants/years';

const Metric = styled(
  ({ value, info, label, labelClassname = 'font-small', className }) => {
    const { year } = useFilterContext().state;
    const showInfo = year === MULTI_YEAR || year === ANNUAL_MULTI_YEAR;
    return (
      <div className={className}>
        <div className={labelClassname}>{label}</div>
        <div>
          <span className="font-xl">{value}</span>
          {showInfo && (
            <span className="font-tiny font-italic ml-1">{info}</span>
          )}
        </div>
      </div>
    );
  },
)`
  font-family: 'Roboto', sans-serif;
`;

export default Metric;
